// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.guideline-update-section .custom-container .content-section {
  background: #E0E7FF;
  padding: 4rem 1rem;
  min-height: 55vh;
}
.guideline-update-section .custom-container .content-section .page-title {
  font-size: 2.2rem;
  text-align: center;
  color: #08245A;
}
.guideline-update-section .custom-container .content-section .page-title::after {
  content: "";
  display: block;
  height: 8px;
  width: 60px;
  background: #08245A;
  margin: 0.7rem auto 0;
  border-radius: 20px;
}
.guideline-update-section .custom-container .content-section .content-body {
  margin: 3rem auto 0;
  max-width: 1180px;
}
.guideline-update-section .custom-container .content-section .content-body .guideline-custom-card {
  max-width: 300px;
}
.guideline-update-section .custom-container .content-section .content-body .guideline-custom-card .guideline-custom-card-header {
  position: relative;
}
.guideline-update-section .custom-container .content-section .content-body .guideline-custom-card .guideline-custom-card-header .image-uploader {
  position: absolute;
  top: 20px;
  left: 150px;
}
.guideline-update-section .custom-container .content-section .content-body .guideline-custom-card .guideline-custom-card-header .image-uploader .icon-update-btn {
  height: 40px;
  width: 40px;
  background: #b4b4b4;
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 100%;
  cursor: pointer;
  transition: 0.4s;
}
.guideline-update-section .custom-container .content-section .content-body .guideline-custom-card .guideline-custom-card-header .image-uploader .icon-update-btn .fa-pencil {
  font-size: 18px;
}
.guideline-update-section .custom-container .content-section .content-body .guideline-custom-card .guideline-custom-card-header .image-uploader .icon-update-btn:hover {
  background: gray;
}
.guideline-update-section .custom-container .content-section .content-body .guideline-custom-card .guideline-custom-card-body {
  display: block;
}
@media (max-width: 325px) {
  .guideline-update-section .custom-container .content-section .content-body .guideline-custom-card .guideline-custom-card-body .delete-btn {
    width: 100%;
    margin-bottom: 0.5rem;
  }
}
@media (min-width: 1200px) and (max-width: 1215px) {
  .guideline-update-section .custom-container .content-section .content-body .guideline-custom-card .guideline-custom-card-body .delete-btn {
    width: 100%;
    margin-bottom: 0.5rem;
  }
}
@media (max-width: 325px) {
  .guideline-update-section .custom-container .content-section .content-body .guideline-custom-card .guideline-custom-card-body .save-btn {
    width: 100%;
    margin-left: 0 !important;
  }
}
@media (min-width: 1200px) and (max-width: 1215px) {
  .guideline-update-section .custom-container .content-section .content-body .guideline-custom-card .guideline-custom-card-body .save-btn {
    width: 100%;
    margin-left: 0 !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/assets/css/adminPages/guideline/style.scss","webpack://./src/assets/css/common/_variables.scss"],"names":[],"mappings":"AAKI;EACE,mBAAA;EACA,kBAAA;EACA,gBAAA;AAJN;AAMM;EACE,iBCEK;EDDL,kBAAA;EACA,cAAA;AAJR;AAMQ;EACE,WAAA;EACA,cAAA;EACA,WAAA;EACA,WAAA;EACA,mBAAA;EACA,qBAAA;EACA,mBAAA;AAJV;AAQM;EACE,mBAAA;EACA,iBAAA;AANR;AAQQ;EACE,gBAAA;AANV;AAQU;EACE,kBAAA;AANZ;AAQY;EACE,kBAAA;EACA,SAAA;EACA,WAAA;AANd;AAQc;EACE,YAAA;EACA,WAAA;EACA,mBAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;AANhB;AAQgB;EACE,eAAA;AANlB;AASgB;EACE,gBAAA;AAPlB;AAaU;EACE,cAAA;AAXZ;AAcc;EADF;IAEI,WAAA;IACA,qBAAA;EAXd;AACF;AAac;EANF;IAOI,WAAA;IACA,qBAAA;EAVd;AACF;AAcc;EADF;IAEI,WAAA;IACA,yBAAA;EAXd;AACF;AAac;EANF;IAOI,WAAA;IACA,yBAAA;EAVd;AACF","sourcesContent":["@import \"../../../../assets/css/common/variables\";\r\n\r\n.guideline-update-section {\r\n\r\n  .custom-container {\r\n    .content-section {\r\n      background: #E0E7FF;\r\n      padding: 4rem 1rem;\r\n      min-height: 55vh;\r\n\r\n      .page-title {\r\n        font-size: $page-title;\r\n        text-align: center;\r\n        color: #08245A;\r\n\r\n        &::after {\r\n          content: \"\";\r\n          display: block;\r\n          height: 8px;\r\n          width: 60px;\r\n          background: #08245A;\r\n          margin: .7rem auto 0;\r\n          border-radius: 20px;\r\n        }\r\n      }\r\n\r\n      .content-body {\r\n        margin: 3rem auto 0;\r\n        max-width: 1180px;\r\n\r\n        .guideline-custom-card{\r\n          max-width: 300px;\r\n\r\n          .guideline-custom-card-header{\r\n            position: relative;\r\n\r\n            .image-uploader {\r\n              position: absolute;\r\n              top: 20px;\r\n              left: 150px;\r\n\r\n              .icon-update-btn {\r\n                height: 40px;\r\n                width: 40px;\r\n                background: #b4b4b4;\r\n                color: #fff;\r\n                display: flex;\r\n                justify-content: center;\r\n                align-items: center;\r\n                border-radius: 100%;\r\n                cursor: pointer;\r\n                transition: .4s;\r\n\r\n                .fa-pencil {\r\n                  font-size: 18px;\r\n                }\r\n\r\n                &:hover {\r\n                  background: gray;\r\n                }\r\n              }\r\n            }\r\n          }\r\n\r\n          .guideline-custom-card-body{\r\n            display: block;\r\n\r\n            .delete-btn {\r\n              @media (max-width: 325px) {\r\n                width: 100%;\r\n                margin-bottom: .5rem;\r\n              }\r\n\r\n              @media (min-width: 1200px) and (max-width: 1215px) {\r\n                width: 100%;\r\n                margin-bottom: .5rem;\r\n              }\r\n            }\r\n\r\n            .save-btn {\r\n              @media (max-width: 325px) {\r\n                width: 100%;\r\n                margin-left: 0 !important;\r\n              }\r\n\r\n              @media (min-width: 1200px) and (max-width: 1215px) {\r\n                width: 100%;\r\n                margin-left: 0 !important;\r\n              }\r\n            }\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n","// Color palette\r\n$color-blue-light: #d0dbff;\r\n$color-blue: #354e80;\r\n$color-blue-dark: #1c2f56;\r\n\r\n$color-sky: #e0e7ff;\r\n\r\n$color-yellow-light: #fffdef;\r\n$color-yellow: #fae205;\r\n\r\n$color-black-30: #e1e2e2;\r\n\r\n$section-heading-font-size: 2.1rem;\r\n$page-title: 2.2rem;\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
